export default __webpack_public_path__ + "static/media/featBg.f19a582e.png";